import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Feed } from 'src/app/models/Feed';
import { Job } from 'src/app/models/Job';
import { AuthService } from 'src/app/services/auth.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { ReactionService } from 'src/app/services/modelService/reaction.service';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss'],
})
export class JobComponent implements OnInit {
  @Input() details = false;

  @Input() feed: Feed = new Job();

  showEmojiBox = false;
  constructor(public reaction: ReactionService, public feedService: FeedService,
    private auth: AuthService, private router: Router) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee();
    this.feedService.feed = this.feed;
  }

  clickEmoji(emoji) {
    this.showEmojiBox = false;
    this.reaction.reaction.reaction = emoji;
    console.log(this.reaction.reaction);
    this.feedService.sendMessage(this.feed);
  }


}
